<template>
  <PComponentLoader :loading="loading">
    <div v-if="!loading">
    <CContainer>
      <div class="grid-stripped">
        <PFRow :label="$pgettext('event_settings.label', 'Show `Use GetPica for your event` banner')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.show_use_get_pica_for_your_event"/>
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Show `Share with a friend` banner')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.show_share_with_friends"/>
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Add Logo GetPica in the upper left of every photo')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm" :checked.sync="form.apply_pica_logo_on_photo"/>
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'HD Deletion Date')">
          <VueCtkDateTimePicker
              v-model="form.hd_deletion_date"
              format="YYYY-MM-DD HH:mm:ss"
              formatted="LL HH:mm:ss"
          />
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Last stay for all media deletion date')">
          <VueCtkDateTimePicker
              v-model="form.last_stay_deletion_date"
              format="YYYY-MM-DD HH:mm:ss"
              formatted="LL HH:mm:ss"
          />
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Media Deletion Date ( for checkin past last stay )')">
          <VueCtkDateTimePicker
              v-model="form.media_deletion_date"
              format="YYYY-MM-DD HH:mm:ss"
              formatted="LL HH:mm:ss"
          />
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Disable checkin from App')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.checkin_from_app_disabled"/>
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Edge System')"
               :help-text="$pgettext('event_settings.help', 'Enable for cruise ships or other edge deployments with external processing infrastructure')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.is_edge"/>
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Use as event aggregator')"
               :help-text="$pgettext('event_settings.help', 'When enabled, this event collects content from other events of the same contract manager assigned to it.')">
          <CSwitch class="mx-1" color="primary" variant="3d" size="sm"
                   :checked.sync="form.is_aggregator"
                   :disabled="!!form.aggregator"/>
        </PFRow>
        <PFRow v-if="!form.is_aggregator"
               :label="$pgettext('event_settings.label', 'Destination aggregator event')"
               :help-text="$pgettext('event_settings.help', 'Select another event of the same contract manager (marked as aggregator) that will collect this event\'s content.')">
          <PSelectKeyValue :options="searchAggregator" :value.sync="form.aggregator"
                           :placeholder="$pgettext('event_settings.placeholder','Select aggregator event')"/>
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Photo Cluster size')">
          <CSelect v-model="form.photo_cluster_size" :options="clusterSizes"/>
        </PFRow>
        <PFRow :label="$pgettext('event.modal.create_new_event.label','Currency')">
          <CurrencySelect v-model="form.currency"/>
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'RW Percentage (Ritenuta d\'Acconto)')"
               :help-text="$pgettext('event_settings.help', 'Leave empty to disable RW calculation in consolidations. Example: 1.16 for 116%')">
          <CInput
              v-model="form.rw_percentage"
              type="number"
              step="0.01"
              min="0"
              :placeholder="$pgettext('event_settings.placeholder', 'e.g. 1.16')"
          />
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Tag Categories')">
          <TagSummary :tags="form.tags" class="mb-2"/>
          <TagEditor ref="tag-editor" @save="form.tags = $event"/>
          <CButton @click="openTagEditor" color="primary">Edit Tags</CButton>
        </PFRow>
        <PFRow :label="$pgettext('event_settings.label', 'Sub Gallery Display')"
               :help-text="$pgettext('event_settings.help', 'Choose how to display sub galleries')">
          <CSelect
              :options="subGalleryDisplayTypes"
              v-model="form.sub_gallery_display"
              :placeholder="$pgettext('event_settings.placeholder','Select sub gallery display type')"
          />
        </PFRow>
        <template v-if="isArchiveEnabled">
          <PFRow :label="$pgettext('event_settings.label', 'Cluster Highlight Pattern')"
                 :help-text="$pgettext('event_settings.help', 'Pattern for displaying cluster info on face hover. Use tag codes in curly braces, e.g. {name} {lastname}<br>{role}')">
            <CInput
                v-model="form.archive_settings.cluster_highlight_pattern"
                :placeholder="$pgettext('event_settings.placeholder', '{name} {lastname}')"
            />
          </PFRow>
          <PFRow :label="$pgettext('event_settings.label', 'Cluster Name Pattern')"
                 :help-text="$pgettext('event_settings.help', 'Pattern for displaying cluster name in headers. Use tag codes in curly braces, e.g. {name} {surname}')">
            <CInput
                v-model="form.archive_settings.cluster_name_pattern"
                :placeholder="$pgettext('event_settings.placeholder', '{name}')"
            />
          </PFRow>
        </template>
        <template v-if="hasPerm('advanced.change_contract')">
          <PFRow :label="$pgettext('event_settings.label','Contract Manager')">
            <PSelectKeyValue :options="searchContractManager" :value.sync="form.contract_manager"
                             placeholder="Select Contract Manager" @input="onChangeContractManager"/>
            <a href="#" @click.prevent="openContractManager" v-translate translate-context="event_wizard"
               v-if="form.contract_manager">Apri contract managerr</a>
          </PFRow>
          <PFRow :label="$pgettext('event_settings.label','Contract')" v-if="form.contract_manager">
            <PSelectKeyValue :options="onSearchContract" :value.sync="form.contract" placeholder="Select Contract"/>
            <a href="#" @click.prevent="openContract" v-translate translate-context="event_wizard"
               v-if="form.contract">Apri contract</a>
          </PFRow>
        </template>
        <template v-if="hasPerm('advanced.change_event_owner')">
          <PFRow :label="$pgettext('event_settings.label','Event Owner')">
            <PSelectKeyValue :options="searchEventOwner" :value.sync="form.event_owner"
                             placeholder="Select Event Owner"/>
          </PFRow>
        </template>
      </div>
    </CContainer>
    <div class="d-flex justify-content-end p-3 border-top">
      <CButton color="success" variant="outline" @click="onReset" ref="reset-button" class="mr-2"
               v-translate translate-context="event_wizard">
        Reset
      </CButton>
      <PButton color="primary" @click="onSave">
        <translate translate-context="event_wizard">Save</translate>
      </PButton>
    </div>
    </div>
  </PComponentLoader>
</template>

<script>
import PFRow from "@/domain/core/components/PFRow.vue";
import TagSummary from "@/domain/eventWizard/components/TagSummary.vue";
import TagEditor from "@/domain/eventWizard/components/TagEditor.vue";
import {mapActions, mapGetters} from "vuex";
import CurrencySelect from "@/domain/core/components/CurrencySelect.vue";
import PSelectKeyValue from "@/domain/core/components/PSelectKeyValue.vue";
import PButton from "@/components/PButton.vue";
import PComponentLoader from "@/domain/core/components/PComponentLoader.vue";
import tagTypes from "@/domain/core/constant/tagTypes";

export default {
  name: "StepEventSettings",
  components: {PComponentLoader, PButton, PSelectKeyValue, CurrencySelect, TagEditor, TagSummary, PFRow},
  props: {
  },
  data() {
    return {
      form: {
        show_use_get_pica_for_your_event: null,
        show_share_with_friends: null,
        apply_pica_logo_on_photo: null,
        hd_deletion_date: null,
        last_stay_deletion_date: null,
        media_deletion_date: null,
        checkin_from_app_disabled: null,
        is_edge: false,
        is_aggregator: false,
        aggregator: null,
        photo_cluster_size: null,
        currency: null,
        rw_percentage: null,
        tags: {},
        sub_gallery_display: null,
        archive_settings: {
          cluster_highlight_pattern: null,
          cluster_name_pattern: null
        },
      }
    }
  },
  emits: ['save'],
  async mounted() {
    if (!this.step_event_settings) {
      await this.fetchStepData('event_settings')
    }
    if (!this.step_template) {
      await this.fetchStepData('template')
    }
    await this.fetchClusterSizes()
    await this.fetchSubGalleryDisplayTypes()
    this.onReset()
  },
  computed: {
    ...mapGetters('core', [
      'recognitionClasses',
      'clusterSizes',
      'subGalleryDisplayTypes',
    ]),
    ...mapGetters('eventWizard', ['isStepLoading', 'step_event_settings', 'step_template']),
    loading() {
      return this.isStepLoading('event_settings')
    },
    isArchiveEnabled() {
      return this.step_template?.allows_archive || false
    },
  },
  methods: {
    ...mapActions('core', [
      'fetchRecognitionClasses',
      'fetchClusterSizes',
      'fetchSubGalleryDisplayTypes',
    ]),
    ...mapActions('eventWizard', [
      'searchContractManager',
      'searchContract',
      'searchEventOwner',
      'searchAggregator',
      'fetchStepData',
    ]),
    onReset() {
      if (this.step_event_settings) {
        this.form = {
          ...this.step_event_settings,
          archive_settings: {
            cluster_highlight_pattern: null,
            cluster_name_pattern: null,
            ...this.step_event_settings.archive_settings
          }
        }
      }
    },
    async onSave() {
      const implicitTagKeys = tagTypes.options().map(t => t.id)
      const formToSave = {
        ...this.form,
        tags: Object.keys(this.form.tags).reduce((acc, key) => {
          if (!implicitTagKeys.includes(key)) {
            acc[key] = this.form.tags[key]
          }
          return acc
        }, {})
      }
      await this.emitPromised('save', formToSave)
      this.onReset()
    },
    openTagEditor() {
      this.$refs['tag-editor'].open(this.form.tags)
    },
    onSearchContract(query) {
      if (!this.form.contract_manager)
        return []
      return this.searchContract({
        contractManager: this.form.contract_manager,
        query: query
      })
    },
    onChangeContractManager() {
      this.form.contract = null
    },
    openContractManager() {
      const url = this.$router.resolve({
        name: 'contract_manager.detail',
        params: {id: this.form.contract_manager}
      }).href;
      window.open(url, '_blank');
    },
    openContract() {
      const url = this.$router.resolve({
        name: 'contract.edit',
        params: {contract_manager: this.form.contract_manager, id: this.form.contract}
      }).href;
      window.open(url, '_blank');
    }
  }
}
</script>
